import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { UserContext } from '../App';

const Unauthorized = () => {
  const navigate = useNavigate();
  // @ts-ignore
  const { unsetUser } = useContext(UserContext);

  const handleLogout = () => {
    unsetUser();
    navigate('/login');
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <div className="text-center">
          <h1 className="text-6xl font-bold text-red-600 mb-4">403</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Access Denied</h2>
          <p className="text-gray-600 mb-6">
            You do not have permission to access this page.
          </p>
          <div className="flex gap-4 justify-center">
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded transition"
            >
              Go Back
            </button>
            <button
              onClick={handleLogout}
              className="px-6 py-2 bg-sky-600 hover:bg-sky-700 text-white rounded transition"
            >
              Log Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
